import {
  isCollateralCodeVehicle,
  isCollateralCodePersonal,
} from './collateralCodes';
import {
  isFacilityCodeVehicle,
  isFacilityCodeCreditCard,
  isFacilityCodePersonal,
  isFacilityCodeSpecialOther,
  isFacilityCodeHouse,
} from './facilityCodes';

export const isCommitmentSpecialOther = commitment =>
  isFacilityCodeSpecialOther(commitment.loantype);

export const isCommitmentHouse = commitment => isFacilityCodeHouse(commitment.loantype);

export const isCommitmentCreditCard = commitment => isFacilityCodeCreditCard(commitment.loantype);

export const isCommitmentPersonal = commitment => !commitment.is_ptptn && (
  isFacilityCodePersonal(commitment.loantype) || (
    isCommitmentSpecialOther(commitment) && (
      isCollateralCodePersonal(commitment.collateral_code) || (
        commitment.collaterals &&
        commitment.collaterals.length > 0 &&
        isCollateralCodePersonal(commitment.collaterals[0].code)
      )
    )
  )
);

export const isCommitmentVehicle = commitment => isFacilityCodeVehicle(commitment.loantype) || (
  isCommitmentSpecialOther(commitment) && (
    isCollateralCodeVehicle(commitment.collateral_code) || (
      commitment.collaterals &&
      commitment.collaterals.length > 0 &&
      isCollateralCodeVehicle(commitment.collaterals[0].code)
    )
  )
);


export const isCommitmentOther = commitment => !commitment.is_ptptn &&
  !isCommitmentVehicle(commitment) &&
  !isCommitmentHouse(commitment) &&
  !isCommitmentCreditCard(commitment) &&
  !isCommitmentPersonal(commitment);



// WEBPACK FOOTER //
// ./src/constants/buyerCommitments.js